// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiSurveyCreator/getCollaboratorTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiSurveyCreator/getCollaborators', payload).then(getData);

export const add = (payload) => http.post('apiSurveyCreator/addCollaborator', payload).then(getData);

export const remove = (payload) => http.post('apiSurveyCreator/removeCollaborator', payload).then(getData);
